import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var ArrowAutofitHeight = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.22 6.78a.75.75 0 0 1-.07-.98l.07-.08 2.37-2.37c.12-.2.37-.35.66-.35.25 0 .48.1.61.28l.05.07 2.37 2.37.07.08c.2.27.2.62.01.89l-.08.1-.08.06c-.26.2-.62.2-.88.01l-.1-.08L17 5.56v3.88c-.06.31-.37.56-.75.56s-.7-.25-.74-.57l-.01-.09V5.56l-1.22 1.22-.08.07c-.3.22-.71.2-.98-.07Zm0 10.44a.75.75 0 0 1 .98-.07l.08.07 1.22 1.22v-3.78c0-.37.34-.66.75-.66.38 0 .7.25.75.57v3.87l1.22-1.22a.75.75 0 0 1 .98-.07l.08.07c.27.27.3.68.08.98l-.08.08-2.36 2.37a.77.77 0 0 1-.67.35.77.77 0 0 1-.66-.35l-2.37-2.37a.75.75 0 0 1 0-1.06ZM6.25 3.99A2.26 2.26 0 0 0 4 6.24v11.5C4 18.98 5 20 6.25 20h4a.75.75 0 0 0 0-1.5h-4a.75.75 0 0 1-.75-.75V6.24c0-.41.34-.75.75-.75h4a.75.75 0 0 0 0-1.5h-4Z"
  }));
});
ArrowAutofitHeight.displayName = 'ArrowAutofitHeight';
export var ArrowAutofitHeightDimensions = {
  height: 24,
  width: 24
};